const vetsActionTypes = {
  getVet: 'user/getVet',
  updateUser: 'user/updateUser',
};

export default vetsActionTypes;
